import { securedAxiosInstance } from "../axios";
import { toSnakeCase, download } from "@estaly/ui";

class RetributionConfigurationsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/retribution_configurations", { params: toSnakeCase(params) });
  }

  updatePercentage(storeId, data) {
    return securedAxiosInstance.put("/retribution_configurations/update_bulk", toSnakeCase({ storeId, ...data }));
  }

  updateFixedPrice(storeId, id, data) {
    return securedAxiosInstance.put(`/retribution_configurations/${id}`, toSnakeCase({ storeId, ...data }));
  }

  async downloadPdf(storeId) {
    return securedAxiosInstance
      .post("/retribution_configurations/pdf", toSnakeCase({ storeId }), { responseType: "blob" })
      .then((response) => {
        download(response.data, "primes-estaly.pdf");
      });
  }
}

export default new RetributionConfigurationsService();
